import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import Routes from '../routes.enum.ts';
import RegistrationStepGuard from './RegistrationStepGuard.tsx';
import { UserRoles } from '../../constants/entities.ts';
import withMe, { MePropsType } from '../../hocs/withMe.tsx';

type Props = MePropsType & {
  children: ReactNode;
};

const RegistrationRoutes = [Routes.RecruiterSetUp];

const RecruiterRegistrationGuard: FC<Props> = ({ children, user }) => {
  const { role, personalProfileCompleted } = user;

  if (role !== UserRoles.Recruiter) {
    return children;
  }

  const isOnRegistrationStep = RegistrationRoutes.includes(window.location.pathname as Routes);

  return (
    <RegistrationStepGuard
      skipAhead={personalProfileCompleted}
      path={Routes.RecruiterSetUp}
      rootChildren={children}
    >
      {isOnRegistrationStep ? <Navigate to={Routes.Dashboard} replace /> : children}
    </RegistrationStepGuard>
  );
};

export default withMe(RecruiterRegistrationGuard);
